export enum TypeResourceMessage {
  OPEN_SCHEDULE = 'OPENSCHEDULE',
  OPENSCHEDULE_PUSH = 'OPENSCHEDULE_PUSH',
  CUSTOMER_REGISTRATION = 'CUSTOMER_REGISTRATION',
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESCHEDULE = 'RESCHEDULE',
  RESCHEDULE_PUSH = 'RESCHEDULE_PUSH',
  CANCEL_SCHEDULE = 'CANCEL_SCHEDULE',
  CANCEL_SCHEDULE_PUSH = 'CANCEL_SCHEDULE_PUSH'
}
